import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';
import UsersStoriesA from './UsersStoriesA';
import VideoListA from './VideoListA';

export default function TabMedia() {
    return (
        <div className={styles.theComp}>
            <UsersStoriesA />
            <VideoListA />
            <EfSpec />
        </div>
    );
}
